<template>
  <SingleItem :singleItem="singleItem"></SingleItem>
</template>

<script>
  import SingleItem from "@/components/singleItem.vue"
  import SingleItemData from "@/assets/single_item.json"

  export default {
    name: "singleItemTest",
    data () {
      return {}
    },
    components: {
      SingleItem
    },
    computed: {
      singleItem () {
        return SingleItemData
      }
    }
  }
</script>
<style scoped></style>
